<template>
  <div class="container">
    <!-- 发图文 -->
    <div class="trends-box">
      <ul>
        <li v-for="(item, index) in imageList" :key="index">
          <van-image fit="cover" class="main-img" :src="item" />
          <img
            class="delete-img"
            src="../../../static/images/icon/delete.png"
            @click="deleteImg(index)"
          />
        </li>
        <li v-if="imageList.length < 9">
          <van-uploader class="upload-img" :after-read="afterRead" multiple />
        </li>
      </ul>
    </div>
    <div class="textarea">
      <div v-if="topicShow || productShow">{{ textVal }}</div>
      <textarea
        v-else
        auto-height
        v-model="textVal"
        placeholder="写下你的动态"
        maxlength="1000"
        @blur.prevent="changeCount()"
      ></textarea>
    </div>

    <div class="handle-box">
      <div class="hb_item" @click.stop="topicChange">
        <div class="iconfont icon-huati1"></div>
        <div>
          <div v-if="topic.length == 0">关联话题</div>
          <div class="hb_scroll special" v-else>
            <div class="hbs_view" v-for="(item, index) in topic" :key="index">
              <div class="hbst_item">
                <div class="overFlowOne">{{ item.TopicName }}</div>
                <div class="s_delete" @click.stop="topicDelete">
                  <van-icon name="cross" color="#aaa" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>

      <div class="hb_item">
        <div class="iconfont icon-dingwei"></div>
        <div>
          <div v-if="!location" @click="getlocation">获取定位</div>
          <div class="hb_scroll" v-else>
            <div class="hbs_view">{{ location }}</div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>

      <div class="hb_item" @click.stop="productChange" v-if="isStore == 1">
        <div class="iconfont icon-product"></div>
        <div>
          <div v-if="!product">关联产品</div>
          <div class="hb_scroll" v-else>
            <div class="hbs_view">
              <div class="hbsp_item">
                <div class="overFlowOne">{{ product.GoodsName }}</div>
                <img :src="product.Thumbnail" />
              </div>
            </div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>
    </div>
    <button class="submitBtn" @click="publishTrends" :disabled="disabled">
      发 布
    </button>

    <!-- 话题弹窗 -->
    <van-overlay v-show="topicShow" z-index="11" @click.stop="onClickHide">
      <div class="wrapper">
        <div class="wrapper-choice-box" @click.stop="controlTap">
          <div class="wcb_top">
            <div>关联话题</div>
            <div @click.stop="topicComplete">完成</div>
          </div>
          <div class="wcb_search">
            <van-search
              shape="round"
              background="transparent"
              placeholder="话题关键词"
              v-model="topicValue"
              maxlength="100"
              @search="topicSearchConfirm"
            />
            <div class="searchBtn" @click.stop="topicSearchConfirm">搜索</div>
          </div>
          <div class="wcb_already">
            还可以关联 {{ 3 - topic.length }} 个话题
          </div>
          <div class="wcb_scroll">
            <div class="wcbs_wrap">
              <div v-for="(item, index) in topicList" :key="index">
                <div
                  class="wcbst_item overFlowOne"
                  :class="item.selected ? 'active' : ''"
                  @click.stop="topicChoice(index)"
                >
                  {{ item.TopicName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 产品弹窗 -->
    <van-overlay v-show="productShow" z-index="11111" @click.stop="onClickHide">
      <div class="wrapper">
        <div class="wrapper-choice-box" @click="controlTap">
          <div class="wcb_top">
            <div>关联展厅产品</div>
            <div @click.stop="productComplete">完成</div>
          </div>
          <div class="wcb_search">
            <van-search
              shape="round"
              background="transparent"
              placeholder="产品关键词"
              v-model="productValue"
              maxlength="100"
              @search="productSearchConfirm"
            />
            <div class="searchBtn" @click.stop="productSearchConfirm">搜索</div>
          </div>
          <div class="wcb_already">只可以关联 1 个产品</div>
          <div class="wcb_scroll">
            <div class="wcbs_wrap wcbsp">
              <div v-for="(item, index) in productList" :key="index">
                <div
                  class="wcbsp_item "
                  :class="item.GoodsId == product.GoodsId ? 'active' : ''"
                  @click.stop="productChoice(index)"
                >
                  <img :src="item.Thumbnail" />
                  <div class="overFlowTwo">{{ item.GoodsName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { loginInfo, authorization } from "@/api/member";
import { memberGoodList } from "@/api/product";
import { createPostPict } from "@/api/publish";
import { postTopicList, postTopicInfo } from "@/api/topic";
import { Icon, Overlay, Toast, Uploader, Image, Search } from "vant";
import COS from "cos-js-sdk-v5";
var cos = new COS({
  // 必选参数
  getAuthorization: function(options, callback) {
    // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    authorization().then((res) => {
      var data = res.Data;
      var credentials = data ? data.Credentials : null;
      if (!data || !credentials) return console.error("credentials invalid");
      callback({
        TmpSecretId: credentials.TmpSecretId,
        TmpSecretKey: credentials.TmpSecretKey,
        XCosSecurityToken: credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.ExpiredTime, // 时间戳，单位秒，如：1580000900
      });
    });
  },
});
var imgList = [];
export default {
  name: "publishPic",
  components: {
    "van-uploader": Uploader,
    "van-icon": Icon,
    "van-overlay": Overlay,
    "van-image": Image,
    "van-search": Search,
  },
  data() {
    return {
      isStore: 0, //是否是企业
      textVal: "",
      disabled: true,
      imageList: [],
      latitude: "", //纬度
      longitude: "", //经度
      location: "", // 定位

      //话题
      topicShow: false,
      topicValue: "",
      topicPageIndex: 1,
      topicTotal: 0,
      topicList: [],
      topic: [{ TopicName: "", TopicId: "" }],
      topicSearched: false, //第一次进来2  有点击搜索1

      //相关产品
      productShow: false,
      productValue: "",
      productPageIndex: 1,
      productTotal: 0,
      productList: [],
      product: "",
    };
  },
  methods: {
    //获取是否为企业
    getStatus() {
      var data = {};
      loginInfo(data).then((res) => {
        this.isStore = res.Data.IsStore;
      });
    },

    // 上传图片
    afterRead(file) {
      let name = file.file.name.split("."); //文件名拆分
      let myDate = new Date();
      let myYear = myDate.getFullYear(); //年
      let myMonth = myDate.getMonth() + 1; //月
      let myTime = myDate.getTime(); // 当前时间
      var code = "";
      for (var i = 1; i <= 6; i++) {
        const num = Math.floor(Math.random() * 10); //6位数随机数
        code += num;
      }
      var rand = myTime + code;
      var dealKeyStr =
        [myYear, myMonth].join("-") +
        "/" +
        [localStorage.getItem("mid"), rand].join("_") +
        "." +
        name[1];
      cos.putObject(
        {
          Bucket: "alighting-img1-1258245685" /* 必须 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
          Key: "memberpost/" + dealKeyStr /* 必须 */,
          Body: file.file, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function(err, data) {
          const location = "https://" + data.Location;
          imgList.push(location);
          console.log("imgList", imgList);
        },
        (this.imageList = imgList),
        (this.imageList = imgList)
      );

      this.disabled = false;
    },

    // 删除图片
    deleteImg(index) {
      let imgList = this.imageList;
      imgList.splice(index, 1);
      this.imageList = imgList;
    },

    //获取位置
    getlocation: function() {
      var geolocation = new qq.maps.Geolocation();
      geolocation.getIpLocation(
        (position) => {
          this.longitude = position.lng;
          this.latitude = position.lat;
          this.location = position.province + position.city;
          this.disabled = false;
        },
        () => {
          this.location = "err";
          console.log("err");
        }
      );
    },

    //显示话题弹窗
    topicChange() {
      var list = this.topicList;
      list.forEach((item, index) => {
        item.selected = false;
      });
      this.topicShow = !this.topicShow;
      this.getTopicHandle();
    },

    //点击遮罩层隐藏
    onClickHide() {
      this.topicShow = false;
      this.productShow = false;
    },

    //控制弹窗区域点击
    controlTap() {
      return false;
    },

    //完成隐藏话题
    topicComplete() {
      this.topicShow = false;
    },

    // 话题输入框确认查询
    topicSearchConfirm() {
      this.topicPageIndex = 1;
      this.topicSearched = true;
      this.getTopicHandle();
    },

    //获取话题详情
    getTopicDatail() {
      var that = this;
      var data = {
        TopicId: Number(that.$route.query.hid),
      };
      postTopicInfo(data).then((res) => {
        that.topic[0].TopicName = res.Data.TopicName;
        that.topic[0].TopicId = res.Data.TopicId;
      });
    },

    //获取话题列表
    getTopicHandle() {
      var that = this;
      var data = {
        CateId: 0,
        Type: that.topicSearched ? 1 : 2, //全部 1热门 2推荐
        Keyword: that.topicValue,
        Page: {
          PageSize: 15,
          PageIndex: that.topicPageIndex,
        },
      };
      postTopicList(data).then((res) => {
        if (that.topicPageIndex == 1) {
          that.topicList = [...res.Data.List];
        } else {
          that.topicList = [...that.topicList, ...res.Data.List];
        }
        that.topicTotal = res.Data.Total;
        if (that.topicList.length >= that.topicTotal) {
          console.log("数据加载完毕");
        } else {
          if (that.topicList.length > 0) {
            that.topicPageIndex = that.topicPageIndex += 1;
            that.getTopicHandle();
          } else {
            console.log("底部了");
          }
        }
      });
    },

    //话题item选择
    topicChoice(index) {
      var list = this.topicList;
      if (this.topic.length >= 3 && !list[index].selected) {
        Toast("最多关联3个话题");
        return;
      } else if (list[index].TopicId == this.topicId && list[index].selected) {
        this.topicId = null;
      } else {
      }
      list[index].selected = !list[index].selected;
      var topic = [];
      list.forEach(function(item, index) {
        if (item.selected) {
          topic.push(item);
        }
      });
      this.topicList = list;
      this.topic = topic;
    },

    //话题删除
    topicDelete(index) {
      var idx = index;
      var topic = this.topic;
      console.log("话题删除的下标值", idx);
      topic.splice(idx, 1);
      this.topic = topic;
    },

    // 产品输入框确认查询
    productSearchConfirm() {
      this.productPageIndex = 1;
      this.getProductHandle();
    },

    //展开产品弹窗
    productChange() {
      this.productShow = !this.productShow;
      this.getProductHandle();
    },

    //完成隐藏产品弹窗
    productComplete() {
      this.productShow = false;
    },

    //获取产品列表
    getProductHandle() {
      var that = this;
      var data = {
        Keyword: that.productValue,
        Page: {
          PageSize: 15,
          PageIndex: that.productPageIndex,
        },
      };
      memberGoodList(data).then((res) => {
        if (that.productPageIndex == 1) {
          that.productList = [...res.Data.List];
        } else {
          that.productList = [...that.productList, ...res.Data.List];
        }
        that.productTotal = res.Data.Total;
        if (that.productList.length >= that.productTotal) {
          console.log("数据加载完毕");
        } else {
          if (that.productList.length > 0) {
            that.productPageIndex = that.productPageIndex += 1;
            that.getProductHandle();
          } else {
            console.log("底部了");
          }
        }
      });
    },

    //产品item选择
    productChoice(index) {
      var index = index;
      this.product = this.product
        ? this.product.GoodsId == this.productList[index].GoodsId
          ? null
          : this.productList[index]
        : this.productList[index];
      this.disabled = false;
    },

    //失去焦点
    changeCount() {
      this.disabled = false;
    },
    //发布图片动态
    publishTrends() {
      var that = this;
      var topicIds = [];
      if (that.topic.length > 0) {
        that.topic.forEach(function(item, index) {
          topicIds.push(item.TopicId);
        });
      }
      if (
        that.imageList &&
        that.imageList.length == 0 &&
        that.textVal.length == 0
      ) {
        Toast("请输入文字或者上传图片");
        return;
      }
      var data = {
        Content: that.textVal,
        TopicId: topicIds,
        Address: that.location,
        GoodId:
          that.isStore == 1 ? (that.product ? that.product.GoodsId : 0) : 0,
        Lng: that.longitude ? that.longitude : 0,
        Lat: that.latitude ? that.latitude : 0,
        PictList: that.imageList,
      };
      createPostPict(data).then((res) => {
        Toast("发布成功");
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      });
    },
  },

  created() {
    this.getStatus();
  },

  mounted() {
    if (this.$route.query.hid) {
      this.getTopicDatail();
    } else {
      this.topic = [];
    }
  },
};
</script>
<style scoped src="../../../static/css/publish.css"></style>
